import React, { Component } from "react"
import Preloader from "../../components/Preloader"
import { Col, Row } from "@themesberg/react-bootstrap"
import LineChart from "../../components/Charts/LineChart"
import LocationDataTable from "./components/LocationDataTable"
import Tools from "../../utils/Tools"
export default class Spared extends Component {
  constructor(props) {
    super(props)
    this.state = {
      profile: this.props.profile,
      compare: false,
      dashboards_data: this.props.dashboards_data,
    }
  }

  onToggle() {
    if (!this.state.compare) {
      this.setState({ loading: true }, () => {
        this.props.updateLastPeriodResults(() => {
          this.setState({
            compare: !this.state.compare,
            loading: false,
          })
        })
      })
    } else {
      this.setState({ compare: !this.state.compare })
    }
  }

  render() {
    return (
      <>
        <div
          className="dashboards-content"
          style={{
            display: "flex",
            flexDirection: "column",
            paddingBottom: 80,
          }}
        >
          {this.props.dashboards_data !== undefined &&
            this.props.dashboards_data !== {} &&
            this.props.dashboards_data.res !== undefined && (
              <>
                <Row>
                  <LineChart
                    totalTitle={"CO2 " + window.strings.spared + ":"}
                    total={
                      Math.round(
                        this.props.dashboards_data.res.data.total_co2 * 10
                      ) / 10
                    }
                    unit={"t"}
                    lastMonth={
                      this.props.dashboards_data.spared_stats.lastMonth
                    }
                    evo={
                      Math.round(
                        this.props.dashboards_data.spared_stats.lastMonth_perc *
                          10
                      ) / 10
                    }
                    frequency={this.props.dashboards_data.frequency}
                    exportCharges={this.props.exportCharges}
                    currentMonth={false}
                    compare={this.state.compare}
                    onToggle={this.onToggle}
                    labels={this.props.dashboards_data.labels}
                    datasets={[
                      {
                        type: "line",
                        label: "CO2 " + window.strings.spared,
                        borderColor: "#07B865",
                        borderWidth: 4,
                        backgroundColor: [
                          "#f38b4a",
                          "#56d798",
                          "#ff8397",
                          "#6970d5",
                          "#f38b4a",
                          "#56d798",
                          "#ff8397",
                          "#6970d5",
                          "#f38b4a",
                          "#56d798",
                          "#ff8397",
                          "#6970d5",
                        ],
                        fill: false,
                        data: this.props.dashboards_data.spared,
                        yAxisID: "left-y-axis",
                        pointRadius: 10,
                        pointBackgroundColor: "transparent",
                        pointBorderWidth: 0,
                        pointHoverRadius: 10,
                        pointHoverBorderWidth: 0,
                        pointHoverBorderColor: "transparent",
                        pointBorderColor: "transparent",
                        pointHoverBackgroundColor: "#07B865",
                        tension: 0.3,
                        freq: this.props.dashboards_data.frequency,
                        evo: this.props.dashboards_data.spared_var,
                      },
                      {
                        type: "line",
                        label: window.strings.chargersLastYear,
                        borderColor: "rgba(98, 117, 122, 0.6)",
                        borderWidth: 2,
                        borderDash: [7, 5],
                        fill: false,
                        data: this.state.compare
                          ? this.props.dashboards_data.last_freq_spared
                          : [],
                        yAxisID: "left-y-axis",
                        pointRadius: 10,
                        pointBackgroundColor: "transparent",
                        pointBorderWidth: 0,
                        pointHoverRadius: 10,
                        pointHoverBorderWidth: 0,
                        pointHoverBorderColor: "transparent",
                        pointBorderColor: "transparent",
                        pointHoverBackgroundColor: "rgba(98, 117, 122, 1)",
                        tension: 0.3,
                        freq: this.props.dashboards_data.frequency,
                        evo: this.props.dashboards_data.spared_var,
                      },
                    ]}
                  />
                </Row>
                {this.props.navLocation && (
                  <Row style={{ marginTop: 20 }}>
                    <Col>
                      <LocationDataTable
                        metricTotalTitle={window.strings.totalCO2Spared + ":"}
                        unit={"t"}
                        subtitle={""}
                        metricTotal={
                          Math.round(
                            this.props.dashboards_data.res.data.total_co2 * 10
                          ) / 10
                        }
                        lastMonth={
                          this.props.dashboards_data.spared_stats.lastMonth
                        }
                        evo={
                          Math.round(
                            this.props.dashboards_data.spared_stats
                              .lastMonth_perc * 10
                          ) / 10
                        }
                        frequency={this.props.dashboards_data.frequency}
                      />
                    </Col>
                    <Col>
                      <LocationDataTable
                        metricTotalTitle={
                          (this.props.dashboards_data.frequency == "horaria"
                            ? window.strings.hour
                            : this.props.dashboards_data.frequency == "dia"
                            ? window.strings.day
                            : this.props.dashboards_data.frequency == "semanal"
                            ? window.strings.week
                            : this.props.dashboards_data.frequency == "mês"
                            ? window.strings.month
                            : window.strings.year) +
                          " " +
                          window.strings.withMoreSpared +
                          ":"
                        }
                        unit={""}
                        metricTotal={
                          this.props.dashboards_data.frequency == "horaria"
                            ? this.props.dashboards_data.best_spared_date.date
                                .hora + "h "
                            : this.props.dashboards_data.frequency == "dia"
                            ? this.props.dashboards_data.best_spared_date.date
                                .dia +
                              " " +
                              Tools.getMonthString(
                                this.props.dashboards_data.best_spared_date.date
                                  .mes
                              )
                            : this.props.dashboards_data.frequency == "semanal"
                            ? this.props.dashboards_data.best_spared_date.date
                                .week
                            : this.props.dashboards_data.frequency == "mês"
                            ? Tools.getMonthString(
                                this.props.dashboards_data.best_spared_date.date
                                  .mes
                              )
                            : this.props.dashboards_data.best_spared_date.date
                                .ano
                        }
                        subtitle={
                          this.props.dashboards_data.frequency == "ano"
                            ? ""
                            : this.props.dashboards_data.best_spared_date.date
                                .ano
                        }
                        lastMonth={
                          this.props.dashboards_data.spared_stats.lastMonth
                        }
                        evo={undefined}
                        frequency={undefined}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}
        </div>
        {this.state.loading && <Preloader show={true} />}
      </>
    )
  }
}
